import { BadgeCheck, Search, ExternalLink, MapPin } from "lucide-react";
import type { SearchResult } from "@/pages/SearchPage";

const ListingCard = ({ result }: { result: SearchResult }) => {
  return (
    <div className="bg-card border rounded-2xl overflow-hidden shadow-card-hover">
      {/* Header bar */}
      <div className="bg-gradient-hero px-6 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-7 h-7 bg-primary-foreground/20 rounded-lg flex items-center justify-center">
            <Search className="w-3.5 h-3.5 text-primary-foreground" />
          </div>
          <span className="font-display font-bold text-primary-foreground text-sm">bnbxo</span>
        </div>
        <div className="flex items-center gap-1.5 bg-primary-foreground/20 rounded-full px-3 py-1">
          <BadgeCheck className="w-3.5 h-3.5 text-primary-foreground" />
          <span className="text-xs text-primary-foreground font-semibold">Listing Found</span>
        </div>
      </div>

      {/* Main content with photo */}
      <div className="flex gap-0">
        {/* Photo */}
        {result.mainImageUrl && (
          <div className="w-36 md:w-44 flex-shrink-0">
            <img
              src={result.mainImageUrl}
              alt={result.realPropertyName || result.propertyTitle}
              className="w-full h-full object-cover"
            />
          </div>
        )}

        {/* Info */}
        <div className="flex-1 p-5 flex flex-col justify-center min-w-0">
          {result.realPropertyName ? (
            <>
              <p className="font-display font-bold text-lg leading-tight mb-1 truncate">
                {result.realPropertyName}
              </p>
              <p className="text-xs text-muted-foreground mb-2 truncate">
                Listed as: {result.propertyTitle}
              </p>
            </>
          ) : (
            <p className="font-display font-bold text-lg leading-tight mb-2 truncate">
              {result.propertyTitle}
            </p>
          )}

          <p className="text-sm text-muted-foreground mb-3">
            Hosted by {result.hostName}
          </p>

          {result.platformPrice && (
            <div className="flex items-center gap-2">
              <span className="bg-secondary rounded-lg px-3 py-1.5 text-sm font-semibold">
                ${result.platformPrice}<span className="text-xs font-normal text-muted-foreground">/night</span>
              </span>
              <span className="text-xs text-muted-foreground capitalize">on {result.platform}</span>
            </div>
          )}

          {result.knowledgeGraphUrl && (
            <a
              href={result.knowledgeGraphUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-1 text-xs font-semibold text-primary hover:underline mt-2 w-fit"
            >
              <ExternalLink className="w-3 h-3" />
              Owner's Site
            </a>
          )}
        </div>
      </div>
    </div>
  );
};

export default ListingCard;
